import React from 'react';
import ProgressView from '../../components/Admin/ProgressView';

const ProgressPage = () => {
  return <ProgressView />;
};

export default ProgressPage;